import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useRecipePopup } from "../../contexts/RecipePopupContext.jsx";

/**
 * Redirige /edit-recipe/:id vers l'ouverture du popup d'édition puis retour au dashboard.
 * Le popup s'affiche tout de suite (avec chargement à l'intérieur) au lieu d'attendre la page complète.
 */
const EditRecipeRedirect = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { openEditPopupById } = useRecipePopup();

  useEffect(() => {
    if (!id) {
      navigate("/dashboard", { replace: true });
      return;
    }
    openEditPopupById(id, () => {
      navigate("/dashboard", { replace: true });
    });
    navigate("/dashboard", { replace: true });
  }, [id, openEditPopupById, navigate]);

  return null;
};

export default EditRecipeRedirect;
